import PageHeader from "@/app/shared/page-header";
import RolesGrid from "@/app/shared/roles-permissions/roles-grid";
import routes from "@/routers/routes";
import { fetchRoles, fetchUsers } from "@/server/api-services";
import { Role, User } from "@/types";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "rizzui";

const pageHeader = {
    title: "Role Management",
    breadcrumb: [
        {
            href: "/",
            name: "Home",
        },
        {
            name: "Role Management",
        },
    ],
};

export default function RolesManagementPage() {
    const [roles, setRoles] = useState([] as Role[]);
    const [users, setUsers] = useState([] as User[]);

    useEffect(() => {
        getRoles();
        getUsers();
    }, []);

    async function getRoles() {
        try {
            const response = await fetchRoles();

            const data = response.data as {
                id: string;
                name: string;
                normalizedName: string;
                permission?: string;
            }[];

            const mappedRoles = data.map((role) => {
                return {
                    id: role.id,
                    name: role.name,
                    normalizedName: role.normalizedName,
                    permission: role.permission?.split(","),
                };
            });

            setRoles(mappedRoles);
        } catch (error) {
            console.error("Failed to fetch roles:", error);
        }
    }

    async function getUsers() {
        try {
            const response = await fetchUsers();
            const data = response.data as User[];
            setUsers(data);
        } catch (error) {
            console.error("Failed to fetch users:", error);
        }
    }

    const refreshRoles = () => {
        getRoles();
    };

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            >
                <div className="mt-4 @lg:mt-0">
                    <Link to={routes.userManagement.createRole}>
                        <Button>Create Role</Button>
                    </Link>
                </div>
            </PageHeader>

            <RolesGrid roles={roles} users={users} refreshRoles={refreshRoles} />
        </>
    );
}